import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/brand/gyre-logo-full-pill.png'


const _hoisted_1 = {
  key: 0,
  class: "guest-navbar navbar navbar-default navbar-fixed-top"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "navbar-header" }
const _hoisted_4 = { class: "nav navbar-nav" }
const _hoisted_5 = {
  key: 0,
  class: "jyre-logo-container"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  "data-test": "guest-nav-jyre-logo",
  href: "/home"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Gyre",
    class: "gyre-top-nav-logo"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "nav navbar-nav navbar-right" }
const _hoisted_9 = { class: "dropdown notifications" }

import { computed, onMounted } from "vue";
import Debug from "debug";
import type { UserSelfDocumentApiModel } from "../../api-models";
import GuestSettingsDropdown from "../guest-settings-dropdown.vue";
import UserNotificationsDropdown from "../notifications/user-notifications-dropdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'guest-top-nav',
  props: {
    model: {}
  },
  setup(__props: any) {

const debug = Debug("cs.Navbar");

const props = __props;

const userNeedsToCompleteFoundationsSession = computed(() => {
  return (
    props.model.platformPermissions.includes("FullMembershipAccess") &&
    !props.model.platformPermissions.includes("AdministerPlatform") &&
    !props.model.hasCompletedFoundationsSession
  );
});

onMounted(() => {
  debug("Mounted", props.model);
});

return (_ctx: any,_cache: any) => {
  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              (!userNeedsToCompleteFoundationsSession.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(UserNotificationsDropdown, { "data-test": "guest-nav-notification-bell" })
            ]),
            _createVNode(GuestSettingsDropdown, { showLinkToFoundationsSession: userNeedsToCompleteFoundationsSession.value }, null, 8, ["showLinkToFoundationsSession"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})